var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.modalData.open
        ? _c("sideBarInvoiceModalModal", {
            attrs: { modalData: _vm.modalData, onModalClose: _vm.closeModal },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalChangeQtyData
        ? _c(
            "EmptyCardModal",
            {
              attrs: {
                modalData: _vm.modalChangeQtyData,
                onModalClose: (reset) => (_vm.modalChangeQtyData = null),
                onModalAccept: _vm.updateChangeQty,
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("ChangeQtyBlock", {
                    ref: "changeBlock",
                    attrs: { drug: _vm.modalChangeQtyData.drug },
                  }),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _vm.send_store
              ? _c("div", { staticClass: "card-body" }, [
                  _c(
                    "form",
                    {
                      attrs: { action: "" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.requestCalculation.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "flex" }, [
                        _c("div", [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.send_store,
                                  expression: "send_store",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "send_store" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.send_store = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(
                              _vm.send_store_list,
                              function (store, index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: store.id } },
                                  [
                                    _vm._v(
                                      _vm._s(store.title) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("label", [_vm._v("Склад получатель")]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.receive_store,
                                  expression: "receive_store",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "receive_store" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.receive_store = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "optgroup",
                                { attrs: { label: "МСК" } },
                                _vm._l(
                                  _vm.receive_store_list.filter((s) =>
                                    s.cities.map((c) => c.object_id).includes(1)
                                  ),
                                  function (s) {
                                    return _c(
                                      "option",
                                      { domProps: { value: s.id } },
                                      [
                                        _vm._v(
                                          _vm._s(s.short_title) +
                                            "\n                    "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "optgroup",
                                { attrs: { label: "Регионы" } },
                                _vm._l(
                                  _vm.receive_store_list.filter(
                                    (s) =>
                                      !s.cities
                                        .map((c) => c.object_id)
                                        .includes(1)
                                  ),
                                  function (store, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: store.id },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(store.title) +
                                            "\n                      "
                                        ),
                                        store.cities.length
                                          ? [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(" (")
                                              ),
                                              _vm._l(
                                                store.cities,
                                                function (city, index) {
                                                  return _c("span", [
                                                    _vm._v(
                                                      _vm._s(city.city.name) +
                                                        _vm._s(
                                                          store.cities.length >
                                                            1 &&
                                                            index + 1 <
                                                              store.cities
                                                                .length
                                                            ? ", "
                                                            : ""
                                                        )
                                                    ),
                                                  ])
                                                }
                                              ),
                                              _vm._v(
                                                "\n                        )\n                      "
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("label", [_vm._v("ID препарата для debug")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.debugPrepId,
                                expression: "debugPrepId",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "number" },
                            domProps: { value: _vm.debugPrepId },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.debugPrepId = $event.target.value
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              position: "relative",
                              "min-width": "200px",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info",
                                staticStyle: {
                                  position: "absolute",
                                  bottom: "0",
                                },
                                attrs: { type: "submit" },
                              },
                              [
                                _vm._v(
                                  "\n                  Создать автосписок\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "check_1" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.default_formula,
                                    expression: "default_formula",
                                  },
                                ],
                                staticClass: "from-control",
                                attrs: {
                                  type: "checkbox",
                                  name: "",
                                  id: "check_1",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.default_formula)
                                    ? _vm._i(_vm.default_formula, null) > -1
                                    : _vm.default_formula,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.default_formula,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.default_formula = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.default_formula = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.default_formula = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                  Использовать 60/17\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex" }, [
                        _c(
                          "div",
                          { staticClass: "mt-2" },
                          _vm._l(_vm.showFilter.options, function (opt, value) {
                            return _c(
                              "div",
                              { staticClass: "form-group mb-0" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.showFilter.selected,
                                      expression: "showFilter.selected",
                                    },
                                  ],
                                  attrs: { type: "radio", id: `ch__${value}` },
                                  domProps: {
                                    value: value,
                                    checked: _vm._q(
                                      _vm.showFilter.selected,
                                      value
                                    ),
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        return _vm.$set(
                                          _vm.showFilter,
                                          "selected",
                                          value
                                        )
                                      },
                                      _vm.getDrugs,
                                    ],
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "mb-0",
                                    attrs: { for: `ch__${value}` },
                                  },
                                  [_vm._v(_vm._s(opt))]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.invoicesOnModetare[_vm.send_store] &&
                        _vm.invoicesOnModetare[_vm.send_store][
                          _vm.receive_store
                        ]
                          ? _c(
                              "div",
                              { staticClass: "alert alert-info mt-1" },
                              [
                                _c("p", [
                                  _vm._v(
                                    "На данном направлении есть накладные на сборке"
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.invoicesOnModetare[_vm.send_store][
                                    _vm.receive_store
                                  ],
                                  function (invoice) {
                                    return _c("div", [
                                      _c("p", [
                                        _c("strong", [
                                          _vm._v(_vm._s(invoice.id)),
                                        ]),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(invoice.comment) +
                                            "\n                  "
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("pulse-loader", {
            staticStyle: { "text-align": "center" },
            attrs: { loading: _vm.loading, color: _vm.color },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading && _vm.requests && _vm.debugPrepId
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table table-sm table-hover table-striped table_debug",
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.$AllStores, function (store) {
                      return store.is_active
                        ? _c("tr", [
                            _c("td", [
                              _vm._v(
                                "(" +
                                  _vm._s(store.id) +
                                  ") " +
                                  _vm._s(store.short_title)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.inStores[0][_vm.debugPrepId] &&
                                    _vm.inStores[0][_vm.debugPrepId][store.id]
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.requests.stage_1[_vm.debugPrepId] &&
                                    _vm.requests.stage_1[_vm.debugPrepId]
                                      .top_urgent &&
                                    _vm.requests.stage_1[_vm.debugPrepId]
                                      .top_urgent[store.id]
                                ) + "\n          "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.requests.stage_1[_vm.debugPrepId] &&
                                    _vm.requests.stage_1[_vm.debugPrepId]
                                      .urgent &&
                                    _vm.requests.stage_1[_vm.debugPrepId]
                                      .urgent[store.id]
                                ) + "\n          "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.inStores[1][_vm.debugPrepId] &&
                                    _vm.inStores[1][_vm.debugPrepId][store.id]
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.requests.stage_2[_vm.debugPrepId] &&
                                    _vm.requests.stage_2[_vm.debugPrepId] &&
                                    _vm.requests.stage_2[_vm.debugPrepId][
                                      store.id
                                    ]
                                ) + "\n          "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.inStores[2][_vm.debugPrepId] &&
                                    _vm.inStores[2][_vm.debugPrepId][store.id]
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.requests.stage_1[_vm.debugPrepId] &&
                                    _vm.requests.stage_1[_vm.debugPrepId]
                                      .regular &&
                                    _vm.requests.stage_1[_vm.debugPrepId]
                                      .regular[store.id]
                                ) + "\n          "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.inStores[3][_vm.debugPrepId] &&
                                    _vm.inStores[3][_vm.debugPrepId][store.id]
                                ) + "\n            "
                              ),
                              store.id === _vm.send_store
                                ? _c("span", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          Math.round(
                                            _vm.storeOrdersDrugs
                                              .total_store_request[
                                              _vm.debugPrepId
                                            ] &&
                                              _vm.storeOrdersDrugs
                                                .total_store_request[
                                                _vm.debugPrepId
                                              ].index * 10000
                                          ) / 100
                                        ) +
                                        "%)"
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.storeOrdersDrugs[store.id] &&
                                    _vm.storeOrdersDrugs[store.id][
                                      _vm.debugPrepId
                                    ] &&
                                    _vm.storeOrdersDrugs[store.id][
                                      _vm.debugPrepId
                                    ].store_require
                                ) + "\n            "
                              ),
                              store.id !== _vm.send_store &&
                              _vm.storeOrdersDrugs[store.id] &&
                              _vm.storeOrdersDrugs[store.id][_vm.debugPrepId]
                                ? _c("span", [
                                    _vm._v(
                                      "\n              (" +
                                        _vm._s(
                                          Math.round(
                                            _vm.storeOrdersDrugs[store.id][
                                              _vm.debugPrepId
                                            ].store_require *
                                              _vm.storeOrdersDrugs
                                                .total_store_request[
                                                _vm.debugPrepId
                                              ].index *
                                              100
                                          ) / 100
                                        ) +
                                        ")\n            "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ])
                        : _vm._e()
                    }),
                    0
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.requests
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "flex justify-content-end" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "XLS",
                      className: "btn btn-outline-info mr-1",
                      onClick: _vm.exportXLS,
                      loading: _vm.exportLoading,
                    },
                  }),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: "Создать накладную перемещения",
                      className: "btn btn-success",
                      onClick: _vm.createNewInvoice,
                      loading: _vm.exportLoading,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "table",
                {
                  staticClass:
                    "table mt-2 table-sm table-hover table-striped table-bordered",
                },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      { staticClass: "sticky" },
                      [
                        _c("th", { attrs: { width: "70px" } }),
                        _vm._v(" "),
                        _c("th", [_vm._v("Препарат")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Заявки")]),
                        _vm._v(" "),
                        +_vm.showFilter.selected === 1
                          ? [
                              _c("th", { attrs: { width: "70px" } }, [
                                _vm._v("Бронь"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "70px" } }, [
                                _vm._v("Н.Кол."),
                              ]),
                            ]
                          : [
                              _c("th", { attrs: { width: "170px" } }, [
                                _vm._v("Всего"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "80px" } }, [
                                _vm._v("Ср.бронь"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "80px" } }, [
                                _vm._v("Об.бронь"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "80px" } }, [
                                _vm._v("Запас"),
                              ]),
                            ],
                        _vm._v(" "),
                        _c("th", { attrs: { width: "70px" } }, [
                          _vm._v("Остаток"),
                        ]),
                        _vm._v(" "),
                        _c("th"),
                        _vm._v(" "),
                        _c("th"),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(
                      [..._vm.filteredDrugs, ..._vm.newDrugs],
                      function (drug, index) {
                        return _c(
                          "tr",
                          { key: drug.id },
                          [
                            _c("td", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            drug && drug.id
                              ? [
                                  _c(
                                    "td",
                                    { staticClass: "drug_info" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(drug.title) +
                                          " (" +
                                          _vm._s(drug.id) +
                                          ")\n              "
                                      ),
                                      +drug.pack_set !== 1
                                        ? _c("p", [
                                            _vm._v("комплект: "),
                                            _c("strong", [
                                              _vm._v(_vm._s(+drug.pack_set)),
                                            ]),
                                            _vm._v(" з.у."),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      drug.cool
                                        ? _c("p", [
                                            _c("span", {
                                              staticClass:
                                                "icon icon-snowflake",
                                            }),
                                            _vm._v(" необходим хладагент"),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      drug.pack_comment
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-muted pack_comment",
                                            },
                                            [_vm._v(_vm._s(drug.pack_comment))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      drug.pack_box_comment
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-muted pack_box_comment",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(drug.pack_box_comment)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.drugRequestExtraData[drug.id]
                                        ?.comments
                                        ? _vm._l(
                                            _vm.drugRequestExtraData[drug.id]
                                              .comments,
                                            function (comments, orderId) {
                                              return _vm
                                                .getStoreOrders(drug.id)
                                                .includes(+orderId)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "alert alert-info mb-1 p-1",
                                                    },
                                                    [
                                                      _c("p", [
                                                        _vm._v("заявка: "),
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(orderId)
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        comments,
                                                        function (c) {
                                                          return _c("p", [
                                                            _vm._v(
                                                              _vm._s(c.text)
                                                            ),
                                                          ])
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e()
                                            }
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              : [
                                  _c(
                                    "td",
                                    [
                                      _c("DrugSearchNew", {
                                        ref: "selectDrug",
                                        refInFor: true,
                                        attrs: { onSelect: _vm.selectNewDrug },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                            _vm._v(" "),
                            _c("td", [
                              drug &&
                              drug.id &&
                              _vm.getStoreOrders(drug.id, true)
                                ? _c("div", [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            _vm.openInNewPage("searchOrder", {
                                              ordersId: _vm.getStoreOrders(
                                                drug.id
                                              ),
                                            })
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                показать (" +
                                            _vm._s(
                                              _vm.getStoreOrders(drug.id).length
                                            ) +
                                            ")\n              "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            +_vm.showFilter.selected === 1
                              ? [
                                  _c("td", [
                                    _c("strong", [_vm._v(_vm._s(drug.qty))]),
                                    _vm._v(" "),
                                    drug.qty && +drug.pack_set !== 1
                                      ? _c("span", [
                                          _vm._v(
                                            "з.у. [" +
                                              _vm._s(
                                                Math.round(
                                                  (drug.qty / +drug.pack_set) *
                                                    10
                                                ) / 10
                                              ) +
                                              "к.]"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          drug.new_qty &&
                                            +drug.new_qty !== drug.qty
                                            ? drug.new_qty
                                            : null
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ]
                              : [
                                  _c("td", [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.printRequestTotal(drug)
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.printDrugFigures(
                                            drug,
                                            _vm.requests.stage_2[drug.id] &&
                                              _vm.requests.stage_2[drug.id][
                                                _vm.calculatedStores.in
                                              ]
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.printDrugFigures(
                                          drug,
                                          _vm.requests.stage_3[drug.id] &&
                                            _vm.requests.stage_3[drug.id][
                                              _vm.calculatedStores.in
                                            ]
                                        )
                                      ) + "\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.printDrugFigures(
                                          drug,
                                          _vm.storeRequest[drug.id]
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                            _vm._v(" "),
                            _c("td", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(drug.remain) + " "),
                              +drug.pack_set !== 1
                                ? _c("span", [
                                    _vm._v(
                                      "з.у. [" +
                                        _vm._s(
                                          Math.round(
                                            (drug.remain / +drug.pack_set) * 10
                                          ) / 10
                                        ) +
                                        " к.]"
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-default comments_btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openChangeDrugBlock(drug)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "icon-fa icon-fa-edit text-center",
                                  }),
                                  _vm._v(" "),
                                  drug.invoice_comment
                                    ? _c(
                                        "span",
                                        { staticClass: "badge badge-info" },
                                        [_vm._v("new")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              drug.is_new
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-warning",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeFromNewDrugs(drug.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-trash text-center",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ],
                          2
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex justify-content-between" }, [
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info",
                      on: { click: _vm.addNewDrug },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-plus" })]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mr-0" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: "XLS",
                        className: "btn btn-outline-info",
                        onClick: _vm.exportXLS,
                        loading: _vm.exportLoading,
                      },
                    }),
                    _vm._v(" "),
                    _c("LoadingButton", {
                      attrs: {
                        title: "Создать накладную перемещения",
                        className: "btn btn-success",
                        onClick: _vm.createNewInvoice,
                        loading: _vm.exportLoading,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("strong", [_vm._v("NEW")]),
      _vm._v(" Склад отправитель"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Склад")]),
        _vm._v(" "),
        _c("th", [_vm._v("Наличие - инвойсы - топ срочные")]),
        _vm._v(" "),
        _c("th", [_vm._v("Топ срочные")]),
        _vm._v(" "),
        _c("th", [_vm._v("Срочные брони")]),
        _vm._v(" "),
        _c("th", [_vm._v("На складах после срочных локальных")]),
        _vm._v(" "),
        _c("th", [_vm._v("Запросы срочных к материнским")]),
        _vm._v(" "),
        _c("th", [_vm._v("На складах после срочных дочерних")]),
        _vm._v(" "),
        _c("th", [_vm._v("Обычные брони")]),
        _vm._v(" "),
        _c("th", [_vm._v("На складах после обычных броней")]),
        _vm._v(" "),
        _c("th", [_vm._v("Запрос на запас")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }